module.exports = "<lc-navigation-bar background=\"background--none\"></lc-navigation-bar>\n\n<lc-content-block *ngFor=\"let block of contentblocks\" [lang]=\"dataService.current_language\" [block]=\"block\">\n</lc-content-block>\n\n<lc-footer-bar></lc-footer-bar>\n\n<img height=\"1\" width=\"1\" style=\"display:none;\" alt=\"\" src=\"https://px.ads.linkedin.com/collect/?pid=9884&fmt=gif\" />\n\n    \n     "


//////////////////
// WEBPACK FOOTER
// /Users/matthijs/projects/PHILIPS/philips-dental-pro/shop/src/app/pages/excent-page/excent-page.component.html
// module id = ../../../../../src/app/pages/excent-page/excent-page.component.html
// module chunks = main